export function sqrt32(n) {
	return Math.sqrt(n) | 0;
}
